import type { AuditStatus } from '@/api/types';

export const AUDIT_OUTCOMES: Array<{ key: string; statuses: AuditStatus[] }> = [
  { key: 'resolved', statuses: ['answer_satisfied', 'action_succeeded'] },
  { key: 'escalated', statuses: ['answer_escalated', 'action_failed_escalated', 'action_rejected_escalated'] },
  { key: 'unresolved', statuses: ['action_failed', 'action_rejected', 'error'] },
  { key: 'pending', statuses: ['answer_given', 'action_proposed'] },
];

export const AUDIT_STATUS_GROUPS: Array<{ key: string; statuses: AuditStatus[] }> = [
  { key: 'answer', statuses: ['answer_given', 'answer_satisfied', 'answer_escalated'] },
  {
    key: 'action',
    statuses: [
      'action_proposed',
      'action_succeeded',
      'action_failed',
      'action_failed_escalated',
      'action_rejected',
      'action_rejected_escalated',
    ],
  },
  { key: 'other', statuses: ['error', 'config_change'] },
];
